const touchEvents = {
  start: 'touchstart', end: 'touchend', move: 'touchmove', cancel: 'touchcancel',
};
export default touchEvents;



//////////////////
// WEBPACK FOOTER
// ./node_modules/shorter-js/src/strings/touchEvents.js
// module id = 20
// module chunks = 0